<div class="picker-form-field-container" (click)="isOpen = !isOpen"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin">

  <!-- custom button to open date-range-picker (if defined)-->
  <div #customButton>
    <ng-content></ng-content>
  </div>

  <!-- default date range button -->
  <mat-form-field
    [ngClass]="{ 'picker-default-hidden' : customButton.hasChildNodes() }">
    <!-- calendar icon button -->
    <mat-icon matPrefix fontSet="fa" fontIcon="fa-calendar"></mat-icon>

    <!-- input for start and end dates -->
    <mat-date-range-input
      #rangeInput
      [rangePicker]="picker"
      [max]="maxDate">
      <input matStartDate
        [formControl]="startCtrl"
        [readonly]="true"
        [placeholder]="'dateStart' | translate">
      <input matEndDate
        [formControl]="endCtrl"
        [readonly]="true"
        [placeholder]="'dateEnd' | translate">
    </mat-date-range-input>

    <mat-icon matSuffix fontSet="fa" fontIcon="fa-caret-down"></mat-icon>
  </mat-form-field>
</div>

<!-- calendar popup -->
<mat-date-range-picker #picker
  [opened]="calendarOpened"
  [startAt]="value?.end || null"
  (closed)="dateRangeChanged()">
</mat-date-range-picker>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop="true"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="isOpen = false">
  <ul class="date-range-presets">
    @for (preset of presets; track preset) {
    <li (click)="selectPreset(preset)"
      [ngClass]="{ 'selected': preset.isSelected }">{{ preset.id | translate
      }}</li>
    }
    <li (click)="isOpen = false; calendarOpened= true">{{ 'show_dates' |
      translate }}</li>
  </ul>
</ng-template>